import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";

export class ShapInfo extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ShapInfo, v) : SKIP;
            },
            (v) => {
                return deserialize(ShapInfo, v);
            }
        );
    }

    constructor() {
        super();
        this._checksum = null;
        this._created = false;
        this._level = null;
        this._updated = null;
    }

    get checksum() {
        return this._uid;
    }
    set checksum(value) {
        this._uid = value;
    }

    get created() {
        return this._created;
    }
    set created(value) {
        this._created = value;
    }

    get level() {
        return this._level;
    }
    set level(value) {
        this._level = value;
    }

    get updated() {
        return this._updated;
    }
    set updated(value) {
        this._updated = value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ShapInfo());
        } else if (target instanceof ShapInfo) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ShapInfo, {
    _checksum: alias("checksum", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _level: alias("level", Schema.primitive()),
    _updated: alias("updated", Schema.primitive()),
});
